import { createSlice } from '@reduxjs/toolkit';

const agencySlice = createSlice({
  name: 'agency',
  initialState: { agency: {
    name: '',
    description: '',
    images: [],
    isFavorite: false,
  } },
  reducers: {
    setAgency: (state, action) => {
        const updates = action.payload; // Destructure updates from the action payload
        state.agency = { ...state.agency, ...updates }; // Merge the updates into the state
    },
    setAvailabilityStatus: (state, action) => {
        state.agency.availability_status = action.payload.availability_status;
    }
  },
});

export const { setAgency, setAvailabilityStatus } = agencySlice.actions;

export default agencySlice.reducer;